if (!customElements.get('benefit-cards')) {
  customElements.define(
    'benefit-cards',
    class BenefitCards extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperElement = this.querySelector('.swiper');
        this.resizeFrame = null;
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.init();
        window.addEventListener('resize', this.onResize);
        document.fonts.ready.then(() => this.equalizeHeadings());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
        if (this.swiper) {
          this.swiper.destroy();
          this.swiper = null;
        }
      }

      onResize() {
        if (this.resizeFrame) return;
        this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.equalizeHeadings();
        });
      }

      equalizeHeadings() {
        const headings = [...this.querySelectorAll('.benefit-card__card-heading')];
        headings.forEach((el) => (el.style.minHeight = ''));

        const maxH = headings.reduce((max, el) => Math.max(max, el.offsetHeight), 0);
        if (maxH > 0) headings.forEach((el) => (el.style.minHeight = maxH + 'px'));
      }

      init() {
        try {
          this.swiper = new Swiper(this.swiperElement, {
            slidesPerView: 1.068,
            spaceBetween: 12,
            slidesOffsetAfter: 12,
            slidesOffsetBefore: 12,
            breakpoints: {
              768: {
                slidesPerView: 1.367,
                spaceBetween: 20,
                slidesOffsetAfter: 20,
                slidesOffsetBefore: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 12,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
              },
            },
          });
        } catch (error) {
          console.error('Error initializing Swiper:', error);
        }
      }
    },
  );
}
